module.exports = __webpack_public_path__ + "img/daren_en2.01a09894.jpg";